import React, { useState, useEffect } from 'react';
import axios from 'axios';
import QuickMenu from '../../components/QuickMenu/QuickMenu';

const OrganizationChart = () => {
  const [schemaUrl, setSchemaUrl] = useState('');

  useEffect(() => {
    const fetchSchemaUrl = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/MainPageSettings/GetSiteSettings`);
        setSchemaUrl(response.data.data.organizationSchemaUrl);

      } catch (error) {
        console.error('Error fetching organization schema:', error);
      }
    };

    fetchSchemaUrl();
  }, []);

  return (
    <div className="organization-chart-page mt-5">
      <div className="container">
        <div className="row">
          <QuickMenu />
          <div className="col-lg-10 col-md-7">
            <div className="organization-chart-content">
              <h1 className="page-title mb-3">Organizasyon Şeması</h1>
              <div className="organization-chart-image">
                {schemaUrl && (
                  <img src={schemaUrl} alt="İskenderun Belediyesi Organizasyon Şeması" />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrganizationChart;
